import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Portal} from 'react-portal';
import _ from 'lodash';

import withMacro from './hoc/withMacro';
import MacroList from './MacroList';
import TextArea from 'components/controls/TextArea';

class MacroTextArea extends PureComponent {
    static propTypes = {
        onSearch: PropTypes.func.isRequired,
        onChange: PropTypes.func,
        onUpdateMacro: PropTypes.func.isRequired,
        dropdownList: PropTypes.array,
        dropdownListProcessing: PropTypes.bool,
        macro: PropTypes.string,
        macroDropDownPosition: PropTypes.shape({
            left: PropTypes.number,
            top: PropTypes.number,
        }),
        caretPosition: PropTypes.number,
        value: PropTypes.string,
        patientId: PropTypes.string,
    };

    static defaultProps = {
        dropdownList: [],
        macro: '',
        dropdownListProcessing: false,
        macroDropDownPosition: {
            left: 0,
            top: 0,
        },
        onChange: null,
        patientId: null,
    };
    timer = null;

    componentWillReceiveProps(nextProps) {
        const {macro, onSearch} = this.props;

        if (macro.length !== nextProps.macro.length && onSearch) {
            clearTimeout(this.timer);
            this.timer = setTimeout(this.search, 500);
            this.forceUpdate();
        }
    }

    search = () => {
        const {onSearch, macro, patientId} = this.props;

        if (onSearch && macro.length) {
            onSearch(macro, patientId);
        }

        clearTimeout(this.timer);
        this.timer = null;
        this.forceUpdate();
    };

    handleChange = (e) => {
        const {onChange, onUpdateMacro} = this.props;

        onUpdateMacro(e);
        onChange(e);
    };

    handleSelectMacro = selectedMacro => {
        const {value, onChange, onUpdateMacro, macro} = this.props;
        const newValue = value.replace(`#${macro}`, selectedMacro.text);

        onUpdateMacro(null, true);
        onChange({target: {value: newValue}});
    };

    handleEnter = (event) => {
        const {dropdownList, macro} = this.props;
        if (macro && macro.length > 0 && dropdownList.length === 1) {
            this.handleSelectMacro(dropdownList[0]);
            event.preventDefault();
        }
    };

    render() {
        const {dropdownList, dropdownListProcessing, macroDropDownPosition, macro, ...fieldProps} = this.props;
        const listVisible = !this.timer && Boolean(macro.length) && (Boolean(dropdownList.length) && !dropdownListProcessing);

        return (
            <div>
                <TextArea {...fieldProps} onChange={this.handleChange} onEnter={this.handleEnter} useNativeTextArea/>
                <Portal>
                    <MacroList
                        list={dropdownList}
                        processing={dropdownListProcessing}
                        onSelect={this.handleSelectMacro}
                        visible={listVisible}
                        macroDropDownPosition={macroDropDownPosition}
                    />
                </Portal>
            </div>
        );
    }
}

export default withMacro(MacroTextArea);



// WEBPACK FOOTER //
// ./src/components/controls/MacroTextArea.jsx